import a from "./index966.js";
import t from "./index945.js";
import e from "./index900.js";
function o() {
  this.size = 0, this.__data__ = {
    hash: new a(),
    map: new (e || t)(),
    string: new a()
  };
}
export {
  o as default
};
